import React, { useContext, useState, useRef, useEffect } from 'react'
import GlobalContext from './contexts/Global'
import StoriesContext from './contexts/Stories'
import ProgressContext from './contexts/Progress'
import Story from './Story'
import ProgressArray from './ProgressArray'
import { getStoryControlExemptTarget } from './storyControlExempt'
export default function () {
    const lastTouchAtRef = useRef(0)
    const { width, height, loop, keyboardNavigation } = useContext(GlobalContext)
    const [isDesktopViewport, setIsDesktopViewport] = useState(false)
    const {
        currentId,
        pause,
        next,
        setCount,
        setVideoDuration,
        previous,
        storyCycle,
        toggleState,
    } = useContext(ProgressContext)
    const { stories } = useContext(StoriesContext)

    const logStoryControl = (control, inputMethod = 'pointer') => {
        const activeStory = stories?.[currentId]
        window.logEv('PLAY_THREAD_CONTROL', {
            control,
            source: 'media_player',
            input_method: inputMethod,
            current_index: currentId,
            story_count: stories?.length || 0,
            story_id: activeStory?.id,
            answer_id: activeStory?.answer?.id,
            quest_id: activeStory?.answer?.quest_id || activeStory?.answer?.uptree_quest_id,
            media_kind: activeStory?.media?.kind,
        })
    }

    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return

        const mediaQuery = window.matchMedia('(min-width: 768px)')
        const updateViewport = event => {
            setIsDesktopViewport(event.matches)
        }

        setIsDesktopViewport(mediaQuery.matches)

        if (typeof mediaQuery.addEventListener === 'function') {
            mediaQuery.addEventListener('change', updateViewport)
            return () => mediaQuery.removeEventListener('change', updateViewport)
        }

        mediaQuery.addListener(updateViewport)
        return () => mediaQuery.removeListener(updateViewport)
    }, [])

    useEffect(() => {
        const isClient = typeof window !== 'undefined' && window.document
        if (isClient && typeof keyboardNavigation === 'boolean' && keyboardNavigation) {
            document.addEventListener('keydown', handleKeyDown)
            return () => {
                document.removeEventListener('keydown', handleKeyDown)
            }
        }
    }, [keyboardNavigation])
    const handleKeyDown = e => {
        if (e.key === 'ArrowLeft') {
            logStoryControl('previous', 'keyboard')
            previous()
        } else if (e.key === 'ArrowRight') {
            logStoryControl('next', 'keyboard')
            next()
        }
    }

    const clickPause = e => {
        if (e.target !== e.currentTarget) return false
        e.stopPropagation()
        togglePause()
    }

    const togglePause = () => {
        logStoryControl(pause ? 'play' : 'pause')
        if (pause) toggleState('play', 'story-control')
        else toggleState('pause', 'story-control')
    }

    const mouseUp = (e, type) => {
        if (e.type === 'mouseup' && Date.now() - lastTouchAtRef.current < 750) return
        const exemptTarget = getStoryControlExemptTarget(e)
        if (exemptTarget) {
            e.preventDefault()
            e.stopPropagation()
            if (exemptTarget instanceof HTMLElement) {
                exemptTarget.click()
            }
            return
        }

        e.preventDefault()
        e.stopPropagation()
        logStoryControl(type)
        type === 'next' ? next() : previous()
    }
    const getVideoDuration = duration => {
        setVideoDuration(duration * 1000)
    }

    const controlWidth = isDesktopViewport ? '12%' : '15%'

    return (
        <div style={Object.assign({}, styles.container, { width, height })}>
            <ProgressArray />
            <Story
                action={toggleState}
                playState={pause}
                story={stories[currentId]}
                getVideoDuration={getVideoDuration}
                syncPlayProgress={nextCount => {
                    if (!Number.isFinite(nextCount)) return
                    setCount(Math.max(0, Math.min(100, nextCount)))
                }}
                key={`${currentId}:${storyCycle || 0}`}
            />
            <div className="story-control-container" style={styles.overlay} onClick={clickPause}>
                <div
                    className="story-control story-left-control"
                    style={{ width: controlWidth, zIndex: 999, pointerEvents: 'auto' }}
                    onTouchStart={e => {
                        lastTouchAtRef.current = Date.now()
                    }}
                    onTouchEnd={e => mouseUp(e, 'previous')}
                    onMouseUp={e => mouseUp(e, 'previous')}
                />
                <div
                    className="story-control story-right-control"
                    style={{ width: controlWidth, zIndex: 999, pointerEvents: 'auto' }}
                    onTouchStart={e => {
                        lastTouchAtRef.current = Date.now()
                    }}
                    onTouchEnd={e => mouseUp(e, 'next')}
                    onMouseUp={e => mouseUp(e, 'next')}
                />
            </div>
        </div>
    )
}

/** @type {{ container: React.CSSProperties, overlay: React.CSSProperties }} */
const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        background: '#111',
        position: 'relative',
    },
    overlay: {
        position: 'absolute',
        height: 'inherit',
        width: 'inherit',
        display: 'flex',
        justifyContent: 'space-between',
        pointerEvents: 'none',
    },
}
